<template></template>

<script>
import { refreshToken } from '../../common/refreshToken'
export default {
  name: 'WXLogin',
  created() {
    this.operateUrlParams()
  },
  methods: {
    operateUrlParams() {
      if (location.href.indexOf('=') > 0) {
        //获取并缓存openId
        const openId = location.href.split('=')[1]
        sessionStorage.setItem('openId', openId)
        let targetUri = localStorage.getItem('targetUri')
        let url = `location.href:${location.href},targetUri:${targetUri},openId:${openId}`
        this.getLog(url)
        refreshToken(this).then((res) => {
          if (res.code == 0) {
            //跳转至目标页面
            location.href = targetUri || process.env.VUE_APP_PAGEURL
          }
        })
      } else {
        let targetUri = localStorage.getItem('targetUri')
        let url = `location.href:${location.href},targetUri:${targetUri}`
        this.getLog(url)
      }
    },
    getLog(url) {
      this.$http({
        url: '/live/liveUsers/saveWxLoginLog/',
        method: 'post',
        params: {
          id: (Math.random() * 1000000).toFixed(0),
          url: url,
        },
      })
    },
  },
}
</script>

<style scoped>
</style>
